/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.object.to-string.js";
import axios from 'axios'; // import store from '../store'
// import router from '../router'

import Vue from 'vue';
import { baseUrl } from '@root/_target.js';
import router from '@/router';
import store from '@/store';
import ddRequestConfig from '@/platforms/Dingding/request-config';
import appRequestConfig from '@/platforms/App/request-config';
var isDingding = false;

var _ref = isDingding ? ddRequestConfig : appRequestConfig,
    request = _ref.request,
    responce = _ref.responce;

function factory(baseUrl) {
  var http = axios.create({
    baseURL: baseUrl,
    timeout: 120000
  }); // 请求过滤器

  http.interceptors.request.use(request, function (error) {
    return Promise.reject(error);
  }); // 响应过滤器

  http.interceptors.response.use(responce, function (err) {
    try {
      if (err.message && err.message.res === 'cancel') {
        Vue.$vux.toast.text('不要重复点击');
      }

      if (err.response) {
        switch (err.response.status) {
          case 404:
            Vue.$vux.toast.text('404 error');
            break;

          case 500:
            Vue.$vux.toast.text('500 err');
            break;

          default:
            Vue.$vux.toast.text('unknow err');
        }
      }

      return Promise.reject(err);
    } catch (e) {
      return Promise.reject(e);
    }
  });
  return http;
}

var http = factory(baseUrl);
export { factory };
var methods = ['get', 'post', 'delete', 'put', 'options', 'request'];
methods.forEach(function (method) {
  var temp = http[method];

  http[method] = function () {
    return temp.apply(this, arguments).catch(function (e) {
      throw Error(e.stack);
    });
  };
});
export default http;